import { Link } from "react-router-dom";
import { PageHero, Container, Overline } from "../components/Section";
import { useAuth } from "../lib/auth";
import { BookOpen, Calendar, Users, FileText, UserPlus, ArrowRight, MessageSquare, Megaphone } from "lucide-react";

const TILES = [
  { to: "/members/announcements", icon: Megaphone, title: "Announcement Request", body: "Submit announcements for the bulletin, social media, slides, or email blasts." },
  { to: "/ministry-media", icon: MessageSquare, title: "Ministry Media Request", body: "Request flyers, graphics, or video promotion for your ministry." },
  { to: "/members/directory", icon: Users, title: "Leadership Directory", body: "Names, ministries, and emails for every ministry lead." },
  { to: "/members/resources", icon: BookOpen, title: "Leadership Resources", body: "Devotionals, study guides, internal forms, and giving statements." },
  { to: "/members/schedule", icon: Calendar, title: "Church Schedule", body: "Service times, weekly rhythm, and year-at-a-glance." },
  { to: "/members/forms", icon: FileText, title: "New Member Form", body: "Register a new member into the SMZBT family." },
];

export default function Members() {
  const { user } = useAuth() || {};
  return (
    <div data-testid="members-page">
      <PageHero
        overline="Leadership Portal"
        title={<>Welcome, <span className="brand-gradient-text">leader</span>.</>}
        kicker={user ? `Logged in as ${user.name}. Everything ministry leaders need is right here.` : "Sign in to access leadership resources."}
      />

      <Container className="pb-32">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {TILES.map((t) => (
            <Link
              to={t.to}
              key={t.to}
              className="bg-royal/40 hover:bg-royal/60 p-10 transition-colors group min-h-[220px] flex flex-col"
              data-testid={`leader-tile-${t.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="w-12 h-12 rounded-full brand-gradient flex items-center justify-center mb-5 shadow-lg shadow-magenta/30">
                <t.icon className="h-5 w-5 text-white" />
              </div>
              <h3 className="font-sans text-2xl font-extrabold mb-3 group-hover:text-ember transition-colors">{t.title}</h3>
              <p className="text-white/65 text-sm flex-1">{t.body}</p>
              <div className="mt-6 text-xs uppercase tracking-widest text-ember/80 inline-flex items-center gap-2 group-hover:text-gold font-bold">
                Open <ArrowRight className="h-3 w-3 group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </Container>
    </div>
  );
}
